<template>
<v-app>
    <template>
        <dashboard-core-app-bar v-if="!$route.meta.public && $local_storage.get('id_usuario') > 0 " v-model="expandOnHover" :key="this.store_id_cliente + 888" />
        <dashboard-core-drawer v-if="!$route.meta.public && $local_storage.get('id_usuario') > 0 " :expand-on-hover.sync="expandOnHover" :key="this.store_id_cliente + 8888" />

        <v-content>
            <router-view />
        </v-content>
        <v-layout row v-if="!$route.meta.public && $local_storage.get('id_usuario') > 0 ">
            <v-flex xs12 sm6 offset-sm3 style="right: 400px; bottom: 85px; position: fixed; z-index: 10000; width:380px" v-show="showCardUsers">
                <v-card style="">
                    <div  class="sc-header primary white--text">
                    <div  class="sc-header--title enabled"> <v-icon dark>mdi-view-list</v-icon> USUARIOS 
                    </div>
                        </div>
                   <div class="pa-2">  
                   <v-text-field  v-model="search" label="Buscar" append-icon="search" outlined  rounded ></v-text-field>
                   </div>
                    <v-list subheader style="overflow-y: scroll; height: 445px; ">
                        <v-list-item v-for="item in filteredItems" :key="item.id_usuario" @click.native="selectUser(item)" :class="{userList: true, selected: isSelected(item.id_usuario) }">
                            <v-list-item-avatar>
                                <i class="material-icons">account_circle</i>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-html="item.nombre + ' ' + item.apellidos"></v-list-item-title>
                                <v-list-item-subtitle class="overline" v-html="nombretipo(item.tipo_usuario)"></v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-badge left v-if="item.no_leidos > 0">
                                    <span slot="badge">{{ item.no_leidos }}</span>
                                    <v-icon :class="item.sesion_activa ? 'active' : ''">chat_bubble</v-icon>
                                </v-badge>
                                <v-icon v-else :class="item.sesion_activa ? 'active' : ''">chat_bubble</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>

        <v-fab-transition v-if="!$route.meta.public && $local_storage.get('id_usuario') > 0 ">
            <v-btn x-small style="right: 90px; bottom: 38px; position: fixed" v-show="showUsers" color="#DF7205" dark fab title="Usuarios" @click.native="showCardUsers = !showCardUsers">
                <v-icon>supervisor_account</v-icon>
            </v-btn>
        </v-fab-transition>

      <!-- <beautiful-chat style="z-index:10 !important; margin-right:-20px;" v-if="!$route.meta.public && $local_storage.get('id_usuario') > 0 " @click.native="function(){if(isChatOpen){ store_chat();}}" :participants="participants" :titleImageUrl="titleImageUrl" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="isChatOpen" :close="closeChat" :open="openChat" :showEmoji="false" :showFile="false" :showTypingIndicator="showTypingIndicator" :colors="colors" :alwaysScrollToBottom="alwaysScrollToBottom" :messageStyling="messageStyling" placeholder="Escriba un mensaje aqui" /> -->
        <dialog-loader ref="dialogLoader"></dialog-loader>
       
        <dashboard-core-enotes v-if="!$route.meta.public && $local_storage.get('id_cliente') > 0 " />
        <dashboard-core-etips v-if="!$route.meta.public " />
        <dashboard-core-eq v-if="!$route.meta.public && $local_storage.get('id_cliente') > 0 " />
    </template>

</v-app>
</template>

<script>
import Vue from "vue";
import {
    mapState
} from "vuex";
import DialogLoader from "@/components/DialogLoader";
//import VueNativeSock from "vue-native-websocket";
import axios from "axios";

/*Vue.use(VueNativeSock, "wss://socket.econnectpro.mx/", {
    reconnection: true, // (Boolean) whether to reconnect automatically (false)    
    reconnectionDelay: 1000 // (Number) how long to initially wait before attempting a new (1000)
});*/

//(25-01-2023): Se comenta, siempre se desconectaba de amazon
/*Vue.use(VueNativeSock, "wss://socket.econnectpro.mx/", {
  connectManually: true,
});*/

const vm = new Vue();

export default {
    components: {
        DialogLoader,
        DashboardCoreAppBar: () => import("@/components/layout/AppBar"),
        DashboardCoreDrawer: () => import("@/components/layout/Drawer"),
        DashboardCoreEtips: () => import('@/components/Etips'),
        DashboardCoreEnotes: () => import('@/components/Enotes'),
        DashboardCoreEq: () => import('@/components/Equestion'),
    },
    name: "App",
    data: () => ({
        tipos_user: [],
        fab: false,
        marquee: "",
        search: "",
        expandOnHover: true,
        mostrarmenu: false,
        colortema: false,
        expanded: true,
        rightDrawer: false,
        snackbar: {
            show: false,
            text: "",
            color: ""
        },
        participants: [{
            id: "me",
            name: "Sporte",
            imageUrl: "/static/user.png"
        }], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
        titleImageUrl: "/static/chat.png",
        messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
        newMessagesCount: 0,
        isChatOpen: false, // to determine whether the chat window should be open or closed
        showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user

        colors: {
            header: {
                bg: "#0E4D78",
                text: "#ffffff"
            },
            launcher: {
                bg: "#DF7205"
            },
            messageList: {
                bg: "#ffffff"
            },
            sentMessage: {
                bg: "#0E4D78",
                text: "#ffffff"
            },
            receivedMessage: {
                bg: "#eaeaea",
                text: "#222222"
            },
            userInput: {
                bg: "#f4f7f9",
                text: "#565867"
            }
        }, // specifies the color scheme for the component
        alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
        messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
        users: [],
        showUsers: false,
        showCardUsers: false,
        id_usuario_recibe: 0,
        id_tipo_usuario_cliente: 0,
        id_tipo_usuario_soporte: 0,
        usuario_soporte: {},

        direction: "top",
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: false,
        right: true,
        bottom: true,
        left: false,
        transition: "slide-y-reverse-transition",

    }),
    computed: mapState({
        store_id_cliente() {

            return this.$store.state.id_cliente + this.$store.state.datetime + this.$store.state.trafico + this.$store.state.costing + this.$store.state.sa31 ;
        },
     
        filteredItems() {
            return this.users.filter(item => {
                
                return item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1 
            })
        }
    }),

    mounted() {
        this.$root.$dialogLoader = this.$refs.dialogLoader;
      
    },
    created() {
        window.getApp = this;
        //this.sockets();
        //this.reiniciaWebsocket();      
  
    },
    methods: {
        reiniciaWebsocket: function(){   
            vm.$disconnect();
            vm.$connect();         
            setTimeout(this.reiniciaWebsocket, 8*60000); //Reiniciamos coneccion cada 8 minutos
        },

        store_chat() {

            return this.$store.state.id_cliente;
        },

        playSoundMsg() {
            var audio = new Audio("/sound/msg.mp3");
            audio.play();
        },
        playSoundAlert() {
            var audio = new Audio("/sound/alert.mp3");
            audio.play();
        },
        sockets() {

            this.$options.sockets.onmessage = data => {

                var data = JSON.parse(data.data);
                let message = data["message"];

                if (message != undefined) {
                    if (
                        (message.id_usuario_envia ==
                            this.$local_storage.get("id_usuario") ||
                            message.id_usuario_recibe ==
                            this.$local_storage.get("id_usuario")) &&
                        (message.id_usuario_envia == this.id_usuario_recibe ||
                            message.id_usuario_recibe == this.id_usuario_recibe)
                    ) {
                        if (
                            message.id_usuario_envia == this.$local_storage.get("id_usuario")
                        )
                            message.author = "me";
                        else {
                            message.author = message.nombre_usuario_envia;
                            this.id_usuario_recibe = message.id_usuario_envia;

                            this.participants = [{
                                id: message.nombre_usuario_envia,
                                name: message.nombre_usuario_envia,
                                imageUrl: "/static/user.png"
                            }];
                        }

                        this.messageList.push(message);

                        if (!this.isChatOpen) {
                            for (var i = 0; i < this.users.length; i++) {
                                if (this.users[i].id_usuario == message.id_usuario_envia) {
                                    this.users[i].sesion_activa = true;

                                    if (this.users[i].no_leidos > 0) this.users[i].no_leidos++;
                                    else this.users[i].no_leidos = 1;
                                }
                            }

                            this.newMessagesCount++;
                            this.playSoundMsg();
                        }
                    } else if (
                        message.id_usuario_recibe == this.$local_storage.get("id_usuario")
                    ) {
                        for (var i = 0; i < this.users.length; i++) {
                            if (this.users[i].id_usuario == message.id_usuario_envia) {
                                this.users[i].sesion_activa = true;

                                if (this.users[i].no_leidos > 0) this.users[i].no_leidos++;
                                else this.users[i].no_leidos = 1;
                            }
                        }

                        this.newMessagesCount++;
                        this.playSoundMsg();
                    }
                }
            };
            /*this.$options.sockets.onopen = () => {
                console.log('connected');
            };
            this.$options.sockets.onclose = () => {
                console.log('disconnected');                
            };
            this.$options.sockets.onerror = error => {
                console.log('error-websocket');
                console.log(error);
            };*/
        },

        onMessageWasSent(objMsj) {
            (objMsj.id_usuario_envia = this.$local_storage.get("id_usuario")),
            (objMsj.id_usuario_recibe = this.id_usuario_recibe),
            (objMsj.nombre_usuario_envia = this.$local_storage.get(
                "nombre_usuario"
            )),
            (objMsj.nombre_usuario_recibe = this.participants[0].name),
            this.$socket.send(
                JSON.stringify({
                    message: objMsj
                })
            );
        },
        openChat: async function () {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var objDiv = document.getElementsByClassName("sc-message-list");
            objDiv[0].scrollTop = objDiv[0].scrollHeight;
            // called when the user clicks on the fab button to open the chat
            await this.getTiposUsuario();
            this.isChatOpen = true;
            this.showUsers = true;
            this.showCardUsers = true;
            this.newMessagesCount = 0;
            this.$root.$dialogLoader.hide();
        },
        closeChat() {
            // called when the user clicks on the botton to close the chat
            this.showUsers = false;
            this.showCardUsers = false;
            this.isChatOpen = false;
        },
        nombretipo(tipo){
            let datos = this.tipos_user.filter(t => t.id_tipo_usuario == tipo);
            if(datos.length>0)
            return datos[0].nombre;
            else
                return "No Definido";

        },
        getTiposUsuario: async function () {
            await axios
                .post(this.$hostname + "tipos-usuarios/get_all/")
                .then(async response => {
                    this.tipos_user = response.data;
                    
                    let datos = response.data.filter(function (tipo) {
                        return tipo.nombre == "Cliente";
                    });

                    this.id_tipo_usuario_cliente = datos[0].id_tipo_usuario;

                    datos = response.data.filter(function (tipo) {
                        return tipo.nombre == "Soporte";
                    });

                    this.id_tipo_usuario_soporte = datos[0].id_tipo_usuario;

                    let id_usuario = this.$local_storage.get("id_usuario");
                    let tipo_usuario = this.$local_storage.get("tipo_usuario");
                    var data = {
                        usuario: id_usuario
                    };
                    this.users = [];

                    if (id_usuario > 0) {
                        if (tipo_usuario == "Cliente")
                            data.cliente = this.$local_storage.get("id_cliente");

                     await axios
                            .post(this.$hostname + "usuarios/list_activos/", data)
                            .then(async response => {
                                let id_usuario = this.$local_storage.get("id_usuario");
                                let usuarios = response.data;
                                let id_tipo_usuario_soporte = this.id_tipo_usuario_soporte;

                                /*  let usuario_soporte = response.data.filter(function (usuario) {
                                    return usuario.tipo_usuario == id_tipo_usuario_soporte;
                                });  */
                                let usuario_soporte = usuarios.filter(user => user.tipo_usuario == id_tipo_usuario_soporte);

                                await axios
                                    .post(
                                        this.$hostname + "chat_api/get_unread_messages/", {
                                            sender: id_usuario
                                        }, {
                                            "Content-type": "application/json",
                                            "Access-Control-Allow-Origin": "*",
                                            "cache-control": "no-cache"
                                        }
                                    )
                                    .then(response => {
                                        for (var i = 0; i < usuarios.length; i++) {
                                            for (var key in response.data) {
                                                if (usuarios[i].id_usuario == key) {
                                                    usuarios[i].no_leidos = response.data[key];
                                                    this.newMessagesCount += response.data[key];
                                                }
                                            }
                                        }
                                    })
                                    .catch(error => {});

                                this.users = usuarios;
                                this.users.sort(function(a, b){
                                        if(a['nombre'] > b['nombre'])  
                                            return 1;  
                                        else if(a['nombre'] < b['nombre'])  
                                            return -1;  
                                    
                                        return 0; 
                                    });
                                /* if (tipo_usuario == "Soporte") this.selectUser(usuarios[0]);
                                else this.selectUser(usuario_soporte[0]); */
                                if (usuarios.length > 0) this.selectUser(usuarios[0]);
                            })
                            .catch(error => {
                                console.log(error);
                                console.log("Ocurrió un error al obtener los usuarios.");
                            });
                    }
                })
                .catch(error => {
                    console.log("Ocurrió un error al obtener los tipos de usuario.");
                });
        },

        selectUser: function (usuario) {
            this.messageList = []; // aqui se obtienen los mensajes
            let id_usuario = this.$local_storage.get("id_usuario");
            //this.getMessages(id_usuario, usuario.id_usuario);
            this.id_usuario_recibe = usuario.id_usuario;

            this.participants = [{
                id: usuario.id_usuario,
                name: usuario.nombre + " " + usuario.apellidos,
                imageUrl: usuario.avatar
            }];

            for (var i = 0; i < this.users.length; i++) {
                if (this.users[i].id_usuario == this.id_usuario_recibe) {
                    this.users[i].no_leidos = 0;
                }
            }
        },
        getMessages: function (sender, target) {
            axios
                .post(
                    this.$hostname + "chat_api/get_chat/", {
                        sender: sender,
                        target: target
                    }, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    }
                )
                .then(response => {
                    for (let i = 0; i < response.data.length; i++) {
                        if (
                            response.data[i].id_usuario_envia ==
                            this.$local_storage.get("id_usuario")
                        )
                            response.data[i].author = "me";
                        else response.data[i].author = response.data[i].nombre_envia;
                    }

                    this.messageList = response.data;

                    setTimeout(function () {
                        var objDiv = document.getElementsByClassName("sc-message-list");
                        objDiv[0].scrollTop = objDiv[0].scrollHeight;
                    }, 1000);
                })
                .catch(error => {});
        },
        isSelected: function (id) {
            return this.id_usuario_recibe == id ? true : false;
        },
        sendWhatsapp: function () {
            window.open(
                "https://api.whatsapp.com/send?phone=524921950591&text=Estoy%20interesado!!!",
                "_blank"
            );
        },

        showFacebook: function () {
            FB.CustomerChat.showDialog();
        }
    }
};
</script>
<style scoped>
    .sc-header {
    min-height: 50px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    padding: 5px;
    box-shadow: 0 1px 4px rgba(0,0,0,.2);
    position: relative;
    box-sizing: border-box;
    display: flex;
    }
    .sc-header--title {
  align-self: center;
  padding: 5px;
  flex: 1;
  user-select: none;
  font-size: 12px;
}

.sc-header--title.enabled {
  cursor: pointer;
  border-radius: 5px;
}
</style>